
import React,{useEffect} from 'react';
import {Carousel, Col, Container, Row} from 'react-bootstrap';
import { HashLink as Link } from 'react-router-hash-link';
import {IoIosArrowDown} from 'react-icons/io';

// import pool from '../../images/swimmingPool.jpg';
import Rue from '../../images/Rue.jpg';
import Decathlon from '../../images/Decathlon.jpeg';
import Jockey from '../../images/Jockey.jpeg';
import Puma from '../../images/Puma.jpeg';
import Skechers from '../../images/Skecher.jpeg';
import Levis from '../../images/Levis.jpeg';
import LouisP from '../../images/LouisP.jpeg';
import Vanh from '../../images/Vanh.jpeg';
import JackJones from '../../images/Jack&Jones.jpeg';
import Megamart from '../../images/Megamart.jpeg';
import Asics from '../../images/Asics.jpeg';
import Calvin from '../../images/Calvin.jpeg';
import UnitedC from '../../images/UnitedC.jpeg';
import Under from '../../images/Under.jpeg';
import Addidas from '../../images/Addidas.webp';
import Nike from '../../images/Nike.jpeg';
import ThirdWave from '../../images/ThirdWave.webp';
import CafeNoire from '../../images/CafeNoire.jpeg';
import Itihaas from '../../images/Itihaas.jpeg';
import Charu from '../../images/Charu.jpeg';
import MacDo from '../../images/MacDo.jpeg';
import Haldiram from '../../images/Haldiram.jpeg';
import exterior2 from '../../images/exterior converted/exterior2.jpg';
import A2B from '../../images/A2B.jpeg';
import BurgerKing from '../../images/BurgerKing.jpeg';
import Airport from '../../images/Airport.jpeg';
import BusStop from '../../images/BusStop.jpeg';
import TataBus from '../../images/TataBus.jpeg';
import Railway from '../../images/Railway.jpeg';
import Yelanka from '../../images/Yelanka.jpeg';
import Hebbal from '../../images/Hebbal.jpeg';
import SLK from '../../images/SLK.jpeg';
import NorthGate from '../../images/NorthGate.jpeg';
import Manyata from '../../images/Manyata.jpeg';
import Bhartiya from '../../images/Bhartiya.jpeg';
import Moongate from '../../images/Moongate.png';
import KNS from '../../images/KNS.jpeg';
import Nandy from '../../images/Nandy.jpeg';
import Skan from '../../images/Skan.jpeg';
import Aval from '../../images/Aval.jpeg';
import Temple from '../../images/temple.jpeg';

import Aos from "aos";
import "aos/dist/aos.css";
import './PlacesToVisit.css'
import Gauche from './Gauche';
import Droite from './Droite';
import { Md10K } from 'react-icons/md';

function PlacesToVisit() {
    useEffect(() => {
        window.scroll(0,0)
        Aos.init({duration:2000});
        Aos.init({
            disable: 'mobile'
          });
      }, []);

      
      const shopping = [
        {
            img: Decathlon,
            title:"Decathlon Anubhava",
            text: `Located at 350m and within 5 minutes walk from Saishreyas Residency  ,Decathlon is famous sportsware retailer and manufacturer well known for its great
            quality goods  at extremely reasonable prices.
            The product price range starts from 150 rupees and lesser,
            truly making it the store for all. With their season clearance sales,
            it's like a sports paradise on earth. Click on the following link to navigate to store. `,
             url:'https://goo.gl/maps/WbrgMMiaZkLarFsT8'
          },
          {
            img: Jockey,
            title:"Jockey Factory Outlet",
            text: `Located at 220m and within 3 minutes walk from Saishreyas Residency  ,Jockey International,
            Inc. is an American manufacturer, and retailer of underwear, sleepwear and sportswear for men, women,
            and children. Click on the following link to navigate to store. `,
             url:'https://goo.gl/maps/s4ZNGdo5UchtNcJP7'
          },
          {
            img: Puma,
            title:"Puma Factory Outlet",
            text: `Located at 250m and within 4 minutes walk from Saishreyas Residency Puma’s factory outlet has got everything
            that anyone would need when it comes to sporting goods. Joining a gym? Pick up duffel bags, trainers, sweatbands, socks, and gym wear.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/A66UPDa19r9XdUaQ9'
          },
          {
            img: Skechers,
            title:"Skechers Factory Outlet",
            text: `Located at 100m and within 1 minutes walk from Saishreyas Residency Skechers factory outlet has got everything
            that anyone would need when it comes to athletic and street footware. They are well know for their top quality trainers.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/UcCgjpSCxcggEXjo9'
          },
          {
            img: Levis,
            title:"Levi’s Factory Outlet",
            text: `Buying a new pair of jeans can always be a hassle between your mind and your wallet, right?
            This factory store of Levi's located at 250m and 4 minutes walk from Saishreyas Residency
            offers up to 50% discount on all its items (such as jeans, tops, shirts, etc.) all year round!
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/iZXzN4aJkXkttuo47'
          },
          {
            img: LouisP,
            title:"Louis Phillippe Factory Outlet",
            text: `Located at 1km and within 12 minutes walk from Saishreyas Residency Louis Philippe's factory outlet offers a wide range of men
            premium apparel. For all your corporate meetings or wedding functions ,it has all you need to look sharp.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/hKLVq76ksQ7gTq7f8'
          },
          {
            img: Vanh,
            title:"Van Heusen Factory Outlet",
            text: `Whether you are looking for a new outfit for an upcoming event or just want to browse the latest fashion, Van Heusen Factory Outlet
            is the place to go. It is the go-to place for keeping yourself in sync with the latest trends. This store is located at 1km  from Saishreyas Residency and is within 12 minutes walk.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/5gFDHfL1SZRmQoCd7'
          },
          {
            img: JackJones,
            title:"Jack & Jones",
            text: `Located at 1km from Saishreyas Residency and within 12 minutes walk ,this Jack & Jones store is well furnished.It has a wide variety of collections covering all occasions and fashion trend needs of young men.  
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/XyQx7Ct7iuk8NGZJ7 '
          },
          {
            img: Megamart,
            title:"Megamart",
            text: `Located at 1km from Saishreyas Residency and within 12 minutes walk, Megamart is a venture by Arvind Mills Ltd. And z pioneer in the brand apparel segment in India. It is today, the largest value-retail company in the country. They offer both Domestic as well as International brands of repute.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/2G8gnRHiCYqspcK89'
          },
          {
            img: Asics,
            title:"Asics Exclusive Factory Outlet",
            text: `Located at airport road, Chikkajala, Bengaluru, Karnataka 560025 ,this store is 1km away from Saishreyas Residency and within 12 minutes walk. Asics is a Japanese multinational corporation which produces sports equipment designed for a wide range of sports. 
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/nk8pHhSbLP3iEi2v9'
          },
          {
            img: Calvin,
            title:"Tommy & Calvin",
            text: `Located at NH7 Service Rd, Chikkajala, Bengaluru, Karnataka 562157,this store is 1km away from Saishreyas Residency and within 12 minutes walk. Calvin Klein Inc. is an American fashion house established in 1968. It specializes in leather, lifestyle accessories, home furnishings, perfumery, jewellery, watches and ready-to-wear.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/d2o5DNAkCXYGu1jFA'
          },
          {
            img: UnitedC,
            title:"United Colors of Benetton",
            text: `Located at NH7 Service Rd, Chikkajala, Bengaluru, Karnataka 562157,this store is 1km away
            from Saishreyas Residency and within 12 minutes walk . United Colors of Benetton is a clothing brand
            renowned worldwide for its colors, knitwear expertise and social commitment.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/XJRhZHKF4k9b4p519'
          },
          {
            img: Under,
            title:"Under Armour Factory Outlet",
            text: `Located at NH7 Service Rd, Chikkajala, Bengaluru, Karnataka 562157,this store is 1km away
            from Saishreyas Residency and within 12 minutes walk . Under Armour is an activewear brand known for its apparel,
            shoes & accessories designed for sports & fitness.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/ANA4xk2jyEUgJj9cA'
          },
          {
            img: Addidas,
            title:"Adidas / Reebok Factory Outlet",
            text: `Located at NH7 Service Rd, Chikkajala, Bengaluru, Karnataka 562157,this store is 1km away
            from Saishreyas Residency and within 12 minutes walk. Adidas / Reebok Factory Outlet has got everything
            that anyone would need when it comes to sporting goods. Joining a gym? Pick up duffel bags, trainers, sweatbands, socks, and gym wear.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/jm1wgw1Qco6CyfAx7'
          },
          {
            img: Nike,
            title:"Nike Factory Outlet",
            text: `Located at 5JGP+34, Chikkajala, Bengaluru, Karnataka 562157,this store is 1km away
            from Saishreyas Residency and within 12 minutes walk. Nike Factory Outlet has got everything
            that anyone would need when it comes to sporting goods. Joining a gym? Pick up duffel bags, trainers, sweatbands, socks, and gym wear.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/jm1wgw1Qco6CyfAx7'
          }
      ]

      const Cafe = [
        {
            img: ThirdWave,
            title:"Third Wave Coffee",
            text: `Try out the coffees our customers liked best. From intensely bold to gently light, there’s a flavour and roast for everyone.
            This store is located at 220m  from Saishreyas Residency and is within 3 minutes walk.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/MKVH1hHX9MdTAXaA7'
          },
          {
            img: CafeNoire,
            title:"Cafe Noire",
            text: `A hot cup of coffee or some cold tea, complemented by baked goods, grants the much needed raise of spirit. Cafe Noir Cargo
            (rated 4.1 on NiceLocal) will present you with a selection of familiar drinks and seats to enjoy them .Cafe Noir Cargo is situated
            by the following address: Bengaluru, 562157, Chikkajala, Opposite Decathlon, 220m away from Saishreyas Residency.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/fAFcTpnZZLj6ugm59'
          }
      ]

      const Restaurants = [
        {
            img: Itihaas,
            title:"Itihaas",
            text: `Being 240m away from Saishreyas Residency and within 3 minutes walk, Itihaas Restaurant at Chikkajala makes sure one has a great food experience by offering highly palatable food.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/do2V3wBtDT7xw9fR8'
          },
          {
            img: Charu,
            title:"Chandru Idli’s",
            text: `Being 150m away from Saishreyas Residency and within 2 minutes walk, Chandru Idli’s is well known for their Delicious homemade breakfast dishes at very affortable rates.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/eM4gfDj1BfvQbmd26'
          },
          {
            img: MacDo,
            title:"McDonald",
            text: `Being 12km away from Saishreyas Residency and within 12 minutes drive, Mcdonald is an American Fast Food restaurant well known for their crispy french fries and Delicious Burgers .
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/1YxMjJsMi3eYCT7X6'
          },
          {
            img: Haldiram,
            title:"Haldiram's Express",
            text: `Being 400m away from Saishreyas Residency and within 5 minutes walk, Haldiram's Express is a store well known for its sweets.
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/UPdiGhforKBG8i2Y7'
          },
          {
            img: A2B,
            title:"A2B",
            text: `Being 2km away from Saishreyas Residency and within 5 minutes walk, A2B is a Vegiterian restaurant which offers a wide variety of dishes for quick Bites.
            Click on the following link to navigate to store.`,
             url:'https://goo.gl/maps/L8LWKbhLgByBi6NE9'
          },
          {
            img: BurgerKing,
            title:"Burger King",
            text: `Being 2km away from Saishreyas Residency and within 5 minutes walk, Burger King is a Well-known fast-food chain serving grilled burgers, fries & shakes.. 
            Click on the following link to navigate to store.  `,
             url:'https://goo.gl/maps/ndBK5XCtDL2a41HMA'
          }
      ]

      const Transits =[
        {
            img: Airport,
            title:"Kempegowda International Airport",
            text: `Being 12km away from Saishreyas Residency and within 15 minutes drive, Kempegowda International Airport is a modern aiport serving the Bangalore area with a bus service direct to Mysore. 
            Click on the following link to navigate to airport.  `,
             url:'https://goo.gl/maps/abSd7MCuCbYxFtCg6'
          },
          {
            img: BusStop,
            title:"Kadiganahalli Gate BMTC Bus Stop(towards City)",
            text: `Address: Chikkajala, Karnataka 562157. Its 200m away from Saishreyas Residency and within 3 minites walk.
            Click on the following link to navigate to bus stop.  `,
             url:'https://goo.gl/maps/s2U3i2HorhSwYkT3A'
          },
          {
            img: TataBus,
            title:"Chikkajala BMTC Bus Stop (towards Devanahalli)",
            text: `Address: Chikkajala, Karnataka 562157. Its 1km away from Saishreyas Residency and within 12 minites walk.
            Click on the following link to navigate to bus stop.  `,
             url:'https://goo.gl/maps/YfgEvRpwpAmoFWRN6'
          },
          {
            img: Railway,
            title:"Kempegowda International Airport Railway Station",
            text: `Being 11km away from Saishreyas Residency and within 15 minutes drive, Kempegowda International Airport Railway Station is located at Boovanahalli, Karnataka 562157. 
            Click on the following link to navigate to station.  `,
             url:'https://goo.gl/maps/CLyUSReNiNevMQdo7'
          },
          {
            img: Yelanka,
            title:"Yelahanka Railway Station",
            text: `Being 9km away from Saishreyas Residency and within 20 minutes drive, Yelahanka Railway Station is located at Kamakshiamma Layout, Yelahanka, Bengaluru, Karnataka 560064 
            Click on the following link to navigate to station.  `,
             url:'https://goo.gl/maps/ndBK5XCtDL2a41HMA'
          },
          {
            img: Hebbal,
            title:"Hebbal Junction",
            text: `Being 15km away from Saishreyas Residency and within an 1 hour by BMTC bus, Hebbal Junction is one of the most popular junction in the city.
            Click on the following link to navigate to Hebbal.  `,
             url:'https://goo.gl/maps/ndBK5XCtDL2a41HMA'
          }
      ]

      const BusinessPark = [
        {
            img: SLK,
            title:"SLK Software Services",
            text: `Being 8km away from Saishreyas Residency and within 12min drive, SLK Software Services is located at 3rd & 4th Floor, Tower B, Amin Properties LLP SEZ Survey Number 19, 20, 20/1 Pujanahalli Village, Taluk, Devanahalli, Bengaluru, Karnataka 562110.
            Click on the following link to navigate to Office.  `,
             url:'https://goo.gl/maps/qc3dDBq1Ym5Bm9tt5'
          },
          {
            img: NorthGate,
            title:"North Gate Office Park",
            text: `Being 8km away from Saishreyas Residency and within an 12 minutes drive, NorthGate Office Park is a commercial complex in Bangalore, Karnataka, India.
            Click on the following link to navigate to their Office.  `,
             url:'https://goo.gl/maps/QRdGEpqStXGANs3H7'
          },
          {
            img: Manyata,
            title:"Manyata Tech Park",
            text: `Being 16km away from Saishreyas Residency and within 22 minutes drive, Manyata Tech Park is one of the biggest Tech park in Bangalore city.
            Click on the following link to navigate to site.  `,
             url:'https://goo.gl/maps/rktAd3Zt5vDdMYFfA'
          },
          {
            img: Bhartiya,
            title:"Bhartiya Centre of Information Technology",
            text: `Being 13km away from Saishreyas Residency and within 20 minutes drive, Bhartiya is located at Thanisandra Main Rd, Kannuru, Bengaluru, Karnataka 560064.
            Click on the following link to navigate to site.  `,
             url:'https://goo.gl/maps/aNPGdwMtGvpX5yG97'
          }
      ]

    const ConventionCenter = [
        {
            img: Moongate,
            title:"Moongate",
            text: `Being 2km away from Saishreyas Residency and within 7 minuutes drive, Moongate is located Behind Decathlon Anubhava, International Airport Road, Chikkajala, Bengaluru, Karnataka 562157.
            Click on the following link to navigate to site.  `,
             url:'https://goo.gl/maps/GqbZsPdXvy5qzfXKA'
          },
          {
            img: KNS,
            title:"KNS Convention Centre",
            text: `Being 800M away from Saishreyas Residency and within 10 min walk, KNS is located at No 89, kadiganahalli cross, Bengaluru, Karnataka 562157.
            Click on the following link to navigate to site.`,
             url:'https://goo.gl/maps/gJ9ohhssYK8jMqW38'
          }
    ]

    const SightSeeing =[
        {
            img: Nandy,
            title:"Nandi Hills",
            text: `Being 22km away from Saishreyas Residency and within 40 minutes drive, Nandi Hills is one of the most popular attraction in the city well appreciated for its view above the clouds.
            Click on the following link to navigate to Hebbal.  `,
             url:'https://goo.gl/maps/9Ussy7zZyrVrJD8J7'
          },
          {
            img: Skan,
            title:"Skandagiri Hills",
            text: `Being 40km away from Saishreyas Residency and within 1 hour drive, Skandagiri Hills is a
            Popular hiking trail offering scenic views of the sunrise & sunset among the clouds.
            Click on the following link to navigate to Hebbal.  `,
             url:'https://goo.gl/maps/TWZxJxz6mq1nqXWd6'
          },
          {
            img: Aval,
            title:"Avalabetta Hills",
            text: `Being 70km away from Saishreyas Residency and within 1 hour 20 minutes drive, Avalabetta Hills is One of the best spots around Bangalore for Trekking. 
            Click on the following link to navigate to Hebbal.  `,
             url:'https://goo.gl/maps/bz7GRYw8FnzbbAR68'
          },
          {
            img: Temple,
            title:"Lepakshi Temple",
            text: `Being 100km away from Saishreyas Residency and within 1 hour 40 minutes drive, Lepakshi Temple is one of the most popular attraction in the city well appreciated for its view above the clouds.
            Click on the following link to navigate to Hebbal.  `,
             url:'https://goo.gl/maps/xiGXRZk8ppWd1CvV6'
          }
    ]




    return (
        <div>
            <div className='CarouselWrapperP'>
                {/* <img className = "CarouselPhotoP"
                    src = {Rue}
                    alt = "First slide" /> */}
                    <div className='AmenitiesHeaderWrapperP'>
                        <h1 className='AmenitiesH1'>Places To Visit</h1>
                        <Link to='#transit'>
                            <IoIosArrowDown  className='ArrowDownP'  />
                        </Link>
                    </div>
                    
            </div>
                 {/* <div className='AmenitiesHeaderWrapperP'>
                    <h1 className='AmenitiesH1'>Places To Visit</h1>
                    <Link to=''>
                        <IoIosArrowDown size='60px' />
                    </Link>
                </div> */}
                <Container  fluid className='bodyBackground'>
                      <div className='ContentsWrapper'>
                            <div id='transit' className='AmenitiesHeaderWrapper'>
                                <h1 className='AmenitiesH1P'>Transits</h1>
                            </div>
                            {
                                Transits.map((item,id)=>{
                                    return <Gauche key={id} src={item.img} title={item.title} text={item.text} url={item.url} />
                                })
                            }

                            <div id='business' className='AmenitiesHeaderWrapper'>
                                <h1 className='AmenitiesH1P'>Business Parks</h1>
                            </div>
                            {
                                BusinessPark.map((item,id)=>{
                                    return <Gauche key={id} src={item.img} title={item.title} text={item.text} url={item.url} />
                                })
                            }

                            <div id='sight' className='AmenitiesHeaderWrapper'>
                                <h1 className='AmenitiesH1P'>Sight Seeing</h1>
                            </div>
                            {
                                SightSeeing.map((item,id)=>{
                                    return <Gauche key={id} src={item.img} title={item.title} text={item.text} url={item.url} />
                                })
                            }

                            <div id='restaurant' className='AmenitiesHeaderWrapper'>
                                <h1 className='AmenitiesH1P'>Restaurants</h1>
                            </div>
                            {
                                Restaurants.map((item,id)=>{
                                    return <Gauche key={id} src={item.img} title={item.title} text={item.text} url={item.url} />
                                })
                            }

                        <div id='shopping' className='AmenitiesHeaderWrapper'>
                            <h1 className='AmenitiesH1P'>Shopping</h1>
                        </div>
                        

                        
                            {
                                shopping.map((item,id)=>{
                                    return <Gauche key={id} src={item.img} title={item.title} text={item.text} url={item.url} />
                                })
                            }
                            
                            <div id='cafe' className='AmenitiesHeaderWrapper'>
                                <h1 className='AmenitiesH1P'>Cafes</h1>
                            </div>
                            {
                                Cafe.map((item,id)=>{
                                    return <Gauche key={id} src={item.img} title={item.title} text={item.text} url={item.url} />
                                })
                            }
                            

                            <div id='convention' className='AmenitiesHeaderWrapper'>
                                <h1 className='AmenitiesH1P'>Convention Centers</h1>
                            </div>
                            {
                                ConventionCenter.map((item,id)=>{
                                    return <Gauche key={id} src={item.img} title={item.title} text={item.text} url={item.url} />
                                })
                            }




                            

                            

                </div>
            </Container>

            
        </div>
    )
}

export default PlacesToVisit
